import {buildStyles, CircularProgressbar} from "react-circular-progressbar";


export default function ScoreProgress({className, value, title, color, total, ...props}) {
    let myValue = (value / total) * 100;
    myValue = Math.round(myValue)
    if (!value)
        return null
    return (
        <div className={"flex flex-col gap-4 justify-center  items-center"}>
            <p className={"text-sm font-semibold text-gray-700 "}>{title}</p>
            <div className={" w-[80px] h-[80px] lg:w-[134px] lg:h-[134px]"}>
                <CircularProgressbar
                    value={myValue}
                    text={value + ""}
                    styles={buildStyles({
                        pathColor: color,
                        textColor: color,
                    })}
                />
            </div>

        </div>
    )
}